import { cn } from '@/lib/utils';

type Props = { message: string; classes?: string };

export default function FormattedMessage({ message, classes }: Props) {
    return <div className={cn('whitespace-pre-wrap', classes)}>{message}</div>;
}
